module.exports = __webpack_public_path__ + "img/straight-rail-vertical-stone-path-remnants.85714f49.png";